<template>
	<div class="channel">
		<div class="btnbox">
			<el-button type="primary" size="small" @click="onadd()">申请开通</el-button>
		</div>

		<el-dialog title="申请开通" :visible.sync="dialogVisible" width="60%" :before-close="onclose">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="渠道代码" prop="code">
					<el-input v-model="ruleForm.code"></el-input>
					<div>请输入2-4位英文字母数字组合渠道代码，例如:A,A1,AA等</div>
				</el-form-item>
				<el-form-item label="渠道名称" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item>
					<p class="ts">申请开通渠道，每次需缴纳保证金1000元，提交即扣!请注意!</p>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose">取消</el-button>
				<el-button type="primary" @click="onopenShop()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="渠道配置" :visible.sync="configVisible" width="90%" :before-close="onclose1">
			<channelConfig :checkobj="checkobj" ref="channelConfig" @submit="onsubmit" v-if="configVisible">
			</channelConfig>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose1">取消</el-button>
				<el-button type="primary" @click="onsubconfig()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="扫码批量增减库存" :visible.sync="scanshow" width="80%" :before-close="onclose3">
			<scancode :checkobj="checkobj" v-if="scanshow" @subscan="onsubscan"></scancode>
		</el-dialog>

		<el-dialog :title="filetitle" :visible.sync="uploadVisible" width="600px" :before-close="onclose2">
			<!-- <div class="uploadboxs" v-if="uploadVisible">
				<div class="uploadbox">
					<p>第一步，点击下载模版</p>
					<el-button type="success" size="small" @click="ondownload">下载模版</el-button>
				</div>
				<div class="uploadbox">
					<p>第二步，点击上传模版</p>
					<myupload @resultUrl="onreturnUrl" :uptype="2"></myupload>
					<div class="filenames" v-if="uploaddata.file_name">
						<div class="filename">
							<span>{{uploaddata.file_name}}</span>
							<i class="el-icon-success"></i>
						</div>
					</div>
				</div>
			</div> -->
			
			<div class="uploaddiv">
				<div class="i_b">
					<el-input v-model="uploadtext" placeholder="请上传文件" size="small" :readonly="true"></el-input>
					<myupload @resultUrl="onreturnUrl" :uptype="2"></myupload>
				</div>
				<div class="a" @click="ondownload">下载模版</div>
			</div>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onfile()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :title="addtype == 1?'增加库存':'减少库存'" :visible.sync="formVisible" width="500px" :before-close="onclose4">
			<el-form :model="addForm" :rules="rules" ref="addForm" label-width="60px" class="demo-ruleForm">
				<el-form-item label="款号" prop="style_number" class="item">
					<el-input v-model="addForm.style_number" placeholder="请输入款号"></el-input>
				</el-form-item>
				<el-form-item label="尺码" prop="size" class="item">
					<el-input v-model="addForm.size" placeholder="请输入尺码"></el-input>
				</el-form-item>
				<el-form-item label="数量" prop="num">
					<el-input-number v-model="addForm.num" label="请输入数量"></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose4">取消</el-button>
				<el-button type="primary" @click="onaddform()">确定</el-button>
			</div>
		</el-dialog>
		
		

		<div class="tablebox">
			<div class="filterdiv" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" v-if="filtershow">
					<el-form-item label="">
						<el-input v-model="formfilter.code" placeholder="渠道代码"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.name" placeholder="渠道名称"></el-input>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.state" placeholder="状态">
							<el-option label="状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.audit_state" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>

			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column label="渠道" header-align="center" align="center" min-width="80px" fixed="left">
						<template slot-scope="scope">
							<div>{{scope.row.code}}</div>
							<div>{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="available_delivery_date_str" label="可配货日期" min-width="100px"
						header-align="center" align="center">
					</el-table-column>
					<el-table-column label="截止接单时间" width="70px" header-align="center" align="center">
						<template slot-scope="scope">
							{{scope.row.stop_take_hour+':'+scope.row.stop_take_minute}}
						</template>
					</el-table-column>
					<el-table-column label="发货时间" min-width="80px" header-align="center" align="center">
						<template slot-scope="scope">
							{{scope.row.delivery_time_str}}
						</template>
					</el-table-column>
					<el-table-column label="免费退货比例" width="70px" header-align="center" align="center">
						<template slot-scope="scope">
							{{scope.row.free_return_rate}}%
						</template>
					</el-table-column>
					<el-table-column prop="exceed_rate_deduct" width="70px" label="超比例扣费用" header-align="center"
						align="center">
					</el-table-column>
					<el-table-column prop="after_service_day_number" label="售后自动受理天数" width="80px"
						header-align="center" align="center">
					</el-table-column>
					<el-table-column label="配货率" width="70px"
						header-align="center" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.allocation_rate}}</p>
							<p class="red" v-if="scope.row.allocation_discount!=0">+ {{scope.row.allocation_discount}}</p>
						</template>
					</el-table-column>
					<el-table-column label="发货率" width="70px"
						header-align="center" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.on_time_rate}}</p>
							<p class="red" v-if="scope.row.on_time_discount!=0">+ {{scope.row.on_time_discount}}</p>
						</template>
					</el-table-column>
					<el-table-column label="退货地址与注意事项" min-width="160px" header-align="center" align="center">
						<template slot-scope="scope">
							<p>{{scope.row.return_name}}</p>
							<p>{{scope.row.return_mobile}}</p>
							<p>{{scope.row.return_province_str}} {{scope.row.return_city_str}}
								{{scope.row.return_area_str}} {{scope.row.return_street_str}}
							</p>
							<p>{{scope.row.return_address}}</p>
							<p>{{scope.row.return_notice}}</p>
						</template>
					</el-table-column>
					<el-table-column prop="remark" label="备注" min-width="80px" header-align="center" align="center">
					</el-table-column>
					<el-table-column prop="state_str" label="状态" width="60px" header-align="center" align="center">
					</el-table-column>
					<el-table-column label="开关" min-width="70px" header-align="center" align="center">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.switch" :active-value="1" :inactive-value="2" @change="onClose(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column label="多仓发货" min-width="60px" align="center" header-align="center">
						<template slot-scope="scope">
							<img class="simg" src="../../assets/image/dancang.jpg" :title="alt"
								v-if="scope.row.multi_delivery_switch == 0">
							<img class="simg" src="../../assets/image/duocang.jpg" :title="alt"
								v-if="scope.row.multi_delivery_switch == 1">
						</template>
					</el-table-column>
					<el-table-column prop="stock_update_time_str" label="更新日期" width="100px" header-align="center"
						align="center">
					</el-table-column>
					<el-table-column prop="stock_update_file" label="导入文件名" min-width="90px" header-align="center"
						align="center">
					</el-table-column>
					<el-table-column label="操作" header-align="center" width="140px" align="center" fixed="right">
						<template slot-scope="scope">
							<div class="operation" v-if="scope.row.state == 2">
								<span @click="onconfig(scope.row)">渠道配置</span>
								<span @click="onstorekeeper(scope.row.id)">进销存</span>
								<span @click="onkcdownload(scope.row.id)">库存下载</span>
								<span @click="onuploadbox(1,'库存更新',scope.row.id)" v-if="scope.row.is_jst == 0">库存更新</span>
								<span @click="onuploadbox(2,'库存增加',scope.row.id)" v-if="scope.row.is_jst == 0">批量库存增加</span>
								<span @click="onupdatabox(1,scope.row)" v-if="scope.row.is_jst == 0">手动库存增加</span>
								<span @click="onuploadbox(3,'库存减少',scope.row.id)" v-if="scope.row.is_jst == 0">批量库存减少</span>
								<span @click="onupdatabox(2,scope.row)" v-if="scope.row.is_jst == 0">手动库存减少</span>
								<span @click="onuploadbox(4,'更新库位',scope.row.id)" v-if="scope.row.is_jst == 0">批量更新库位</span>
								<span @click="onscan(scope.row)" v-if="scope.row.is_jst == 0">扫码批量增减库存</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]" :current-page.sync="page" :page-size="pageSize"
					:total="total" v-if="total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Channel',
		data() {
			return {
				formfilter: {
					code: "",
					name: "",
					state: 2
				},

				list: [],
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,

				dialogVisible: false,

				ruleForm: {
					code: "",
					name: ""
				},
				rules: {
					code: [{
						required: true,
						message: '请输入渠道代码',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入渠道名称',
						trigger: 'blur'
					}],
					
					style_number: [{
						required: true,
						message: '请输入款号',
						trigger: 'blur'
					}],
					
					size: [{
						required: true,
						message: '请输入尺码',
						trigger: 'blur'
					}],
					
					num: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}],
					
				},

				checkobj: {},
				configVisible: false,
				uploadVisible: false,
				uploaddata: {
					shop_id: 0,
					file_name: "",
					path: ""
				},
				filetype: 0,
				filetitle: "上传文档",
				scanshow: false,
				
				formVisible: false,
				addtype: "",
				addForm: {
					shop_id: "",
					style_number: "",
					size: "",
					num: ""
				},
				
				uploadtext: "",
				alt: "选择省份，显示该省份的实际运费标准,“单”表示本渠道单仓发货；“多”表示多仓发货，多件的订单可能分多仓发货，尤其是需要发顺丰到付的！“按件”表示渠道的运费计算方式（因多仓发货，按件收费，若下多件，第1件，按首重付费，第2件开始按续重收费），请注意！"
			}
		},

		inject: ['appdata'],

		mounted() {
			this.shopList();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height) + 30;
					this.$refs.tablediv.style.height = "calc(100% - " + num + "px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},

		methods: {
			shopList() {
				var obj = {
					code: this.formfilter.code,
					name: this.formfilter.name,
					state: this.formfilter.state,
					page: this.page,
					limit: this.pageSize
				};

				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onadd() {
				this.dialogVisible = true;
			},

			handleCurrentChange() {
				this.shopList();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.shopList();
			},

			onfilter() {
				this.page = 1;
				this.shopList();
			},

			onreset() {
				this.formfilter.code = "";
				this.formfilter.name = "";
				this.page = 1;
				this.shopList();
			},

			onopenShop() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$axios.post('api/user/open_shop', this.ruleForm).then(res => {
							if (res.data.code == 0) {
								this.$message.success('申请成功');
								this.onclose();
								this.shopList();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onClose(obj) {
				// switch 1 开启 2关闭
				var data = {
					id: obj.id,
					switch: obj.switch
				}
				
				this.$axios.post('api/user/set_shop', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.shopList();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onswitch(v) {
				if (v == 1) {
					return "开启"
				} else {
					return "关闭"
				}
			},

			onkcdownload(id) {
				var data = {
					shop_id: id,
				}
				this.$axios.post('api/user/shop_stock_export', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('请前往任务中心-导出列表下载');
						this.$parent.oncount();
						// 之后需要调任务列表的加载
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onclose() {
				this.dialogVisible = false;
				this.ruleForm.code = "";
				this.ruleForm.name = "";
			},

			onconfig(obj) {
				this.checkobj = obj;
				this.configVisible = true;
			},

			onclose1() {
				this.checkobj = {};
				this.configVisible = false;
			},

			onsubconfig() {
				this.$refs['channelConfig'].onsubmit();
			},

			onsubmit(val) {
				this.$axios.post('api/user/set_shop', val).then(res => {
					if (res.data.code == 0) {
						this.$message.success('配置成功');
						this.onclose1();
						this.shopList();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onuploadbox(n, name, id) {
				this.filetype = n;
				this.filetitle = name;
				this.uploadVisible = true;
				this.uploaddata.shop_id = id;
			},

			ondownload() {
				var url = "";
				//更新库存
				if (this.filetype == 1) {
					url =
						"https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E6%9B%B4%E6%96%B0%E5%BA%93%E5%AD%98%E6%A8%A1%E7%89%88.xls";
				}
				//库存增加
				if (this.filetype == 2) {
					url =
						"https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E5%BA%93%E5%AD%98%E5%A2%9E%E5%8A%A0%E6%A8%A1%E7%89%88.xls";
				}
				//库存减少
				if (this.filetype == 3) {
					url =
						"https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E5%BA%93%E5%AD%98%E5%87%8F%E5%B0%91%E6%A8%A1%E7%89%88.xls";
				}

				//更新库位
				if (this.filetype == 4) {
					url =
						"https://oss.zhidayd.com/%E7%9B%B4%E8%BE%BE%E8%BF%90%E5%8A%A8-%E6%9B%B4%E6%96%B0%E5%BA%93%E4%BD%8D%E6%A8%A1%E7%89%88.xls";
				}
				window.open(url, '_blank');
			},

			onreturnUrl(url, res, file) {
				//原文件名称
				this.uploaddata.file_name = file.name;
				this.uploaddata.path = res.file;
				this.uploadtext = this.uploaddata.file_name;
			},

			onfile() {
				if (!this.uploaddata.shop_id || !this.uploaddata.file_name || !this.uploaddata.path) {
					this.$message.error("请先上传模版");
					return;
				}

				var url = "";

				if (this.filetype == 1) {
					url = "api/user/shop_stock_update";
				}

				if (this.filetype == 2) {
					url = "api/user/shop_stock_inc";
				}

				if (this.filetype == 3) {
					url = "api/user/shop_stock_dec";
				}

				if (this.filetype == 4) {
					url = "api/user/shop_stock_position";
				}

				this.$axios.post(url, this.uploaddata).then(res => {
					if (res.data.code == 0) {
						this.$message.success('上传成功，请前往任务中心-导入列表查看状态');
						this.$parent.oncount();
						this.onclose2();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onclose2() {
				this.uploadVisible = false;
				this.uploaddata = {
					shop_id: 0,
					file_name: "",
					path: ""
				};
				this.uploadtext = "";
				this.filetype = 0;
				this.filetitle = "上传文档";
			},

			onstorekeeper(id) {
				this.$router.push({
					path: '/seller/management/channel/storekeeper',
					query: {
						id: id
					}
				});
			},

			onscan(obj) {
				this.checkobj = obj;
				this.scanshow = true;
			},

			onclose3() {
				this.checkobj = {};
				this.scanshow = false;
			},

			onsubscan() {
				this.onclose3();
				this.shopList();
			},
			
			onupdatabox(n,obj) {
				this.checkobj = obj;
				this.addtype = n;
				this.formVisible = true;
			},
			
			onclose4() {
				this.checkobj = {};
				this.addForm = {
					shop_id: "",
					style_number: "",
					size: "",
					num: ""
				};
				this.addtype = "";
				this.formVisible = false;
			},
			
			onaddform() {
				this.$refs['addForm'].validate((valid) => {
					if (valid) {
						var url = "";
						var obj = JSON.parse(JSON.stringify(this.addForm));
						obj.shop_id = this.checkobj.id;
						if(this.addtype == 1) {
							url="/api/user/shop_stock_inc_hand"
						}
						
						if(this.addtype == 2) {
							url="/api/user/shop_stock_dec_hand";
						}
						
						this.$axios.post(url, obj).then(res => {
							if (res.data.code == 0) {
								this.$message.success('操作成功');
								// this.onclose4();
								this.addForm = {
									shop_id: "",
									style_number: "",
									size: "",
									num: ""
								};
								this.shopList();
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.channel {
		height: 100%;
	}
	.tablediv {
		width: 100%;
	}

	.operation {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		span {
			color: #ff4714;
			cursor: pointer;
		}
	}

	.simg {
		width: 16px;
		height: 16px;
	}
	
	.tablebox {
		height: calc(100% - 104px);
	}
	
	.ts {
		font-size: 16px;
		color: #ff4714;
	}
	
	.red {
		color: red;
	}
	
	.item {
		/deep/ .el-input {
			width: 250px !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/channel.vue